<template>
  <div class="GoodsDetail wide-container">


    <!-- 2. 商品核心信息卡片 (主视觉区域 100% 对应真实接口业务数据) -->
    <!-- 态 1：骨架屏加载态 (消除空白与抖动) -->
    <div class="goods-main-card skeleton-card" v-if="detailLoading">
      <div class="skeleton-shimmer"></div>
      <div class="main-card-layout">
        <div class="gallery-col">
          <div class="sk-image-box"></div>
          <div class="sk-thumbs-row">
            <div class="sk-thumb" v-for="n in 4" :key="n"></div>
          </div>
        </div>
        <div class="decision-col">
          <div class="sk-line sk-title"></div>
          <div class="sk-line sk-sku"></div>
          <div class="sk-price-box"></div>
          <div class="sk-line sk-spec"></div>
          <div class="sk-line sk-qty"></div>
          <div class="sk-buttons-row">
            <div class="sk-btn" v-for="n in 3" :key="n"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 态 2：真实商品核心卡片 -->
    <div class="goods-main-card" v-else>
      <div class="main-card-layout">
        <!-- 左侧：真实画廊与主图展示区 -->
        <div class="gallery-col">
          <div class="main-gallery-stage">
            <span class="corp-self-badge">
              <i class="el-icon-circle-check"></i> 科普特直供 · 框架入库品
            </span>
            <el-carousel
              v-if="detail.rguiigpafo0pe0my && detail.rguiigpafo0pe0my.length"
              ref="carousel"
              height="400px"
              class="carousel-stage"
              :autoplay="false"
              arrow="hover"
              @change="handleCarouselChange"
            >
              <el-carousel-item
                v-for="(item, index) in detail.rguiigpafo0pe0my"
                :key="index"
              >
                <img :src="item.url" :alt="detail.avdrlfwlhg7kywxn || '商品图片'" class="gallery-img" />
              </el-carousel-item>
            </el-carousel>
            <div class="no-img-stage" v-else>
              <i class="el-icon-picture-outline no-img-icon"></i>
              <span>暂无商品实拍图</span>
            </div>
          </div>

          <!-- 缩略图轮播指示器 (当图集多于1张时展示) -->
          <div
            class="thumbnails-strip custom-scrollbar"
            v-if="detail.rguiigpafo0pe0my && detail.rguiigpafo0pe0my.length > 1"
          >
            <button
              v-for="(item, idx) in detail.rguiigpafo0pe0my"
              :key="'thumb-' + idx"
              type="button"
              class="thumb-item"
              :class="{ 'is-active': activeImgIndex === idx }"
              @click="selectThumb(idx)"
            >
              <img :src="item.url" alt="缩略图" />
            </button>
          </div>
        </div>

        <!-- 右侧：采购核心决策区 -->
        <div class="decision-col">
          <!-- 1. 商品主标题 -->
          <h1 class="goods-heading" :title="detail.avdrlfwlhg7kywxn">
            {{ detail.avdrlfwlhg7kywxn || '物料详情' }}
          </h1>

          <!-- 2. 原厂订货号与物料 SKU 编码专属胶囊 (真实绑定主表 levmoblohezp7y50) -->
          <div class="meta-sku-bar" v-if="detail.levmoblohezp7y50">
            <div class="sku-capsule">
              <span class="sku-label"><i class="el-icon-postcard"></i> 物料编码 / SKU:</span>
              <strong class="sku-code font-mono">{{ detail.levmoblohezp7y50 }}</strong>
              <button
                type="button"
                class="sku-copy-link"
                @click="copySku(detail.levmoblohezp7y50)"
                title="复制SKU编码"
              >
                复制
              </button>
            </div>
            <span class="stock-live-badge">
              <span class="live-dot"></span> 协议直供货源
            </span>
          </div>

          <!-- 3. 企业协议价格信息看板 -->
          <div class="price-dashboard">
            <div class="price-primary-row">
              <span class="price-type-label">企业协议价</span>
              <div class="price-amount-wrap">
                <span class="currency">¥</span>
                <span class="amount-number tabular-nums font-mono">{{ formattedPrice }}</span>
              </div>
              <span class="discount-pill">框架专属折扣已生效</span>
            </div>
            <div class="tax-shipping-footer">
              <div class="footer-item">
                <i class="el-icon-document-checked accent-icon"></i>
                <span>开票保障：<strong>支持 13% 增值税专用发票随货同行 · 自动对账</strong></span>
              </div>
              <div class="footer-item">
                <i class="el-icon-truck accent-icon"></i>
                <span>物流保障：<strong>科普特专属专线直达 · 协议直发</strong></span>
              </div>
            </div>
          </div>

          <!-- 4. 规格属性行：计量单位 (真实绑定主表 y8cegh2yyvvqbzwo) -->
          <div class="specs-attributes-box">
            <div class="attr-row" v-if="detail.y8cegh2yyvvqbzwo">
              <span class="attr-label">计量单位</span>
              <div class="unit-capsule">
                <i class="el-icon-check check-mark"></i>
                <span>{{ detail.y8cegh2yyvvqbzwo }}</span>
              </div>
            </div>

            <!-- 5. 采购数量步进器 (仅在可购买状态下展示) -->
            <template v-if="canPurchase">
              <div class="attr-row quantity-row">
                <span class="attr-label">采购数量</span>
                <div class="quantity-picker-wrap">
                  <NumberInput v-model="num" :min="1" :max="999999" />
                  <span class="qty-desc">支持企业按需批量订购</span>
                </div>
              </div>

              <!-- 6. 行动按钮组 (100% 保持已有三大业务功能) -->
              <div class="actions-button-row">
                <!-- 立即购买 -->
                <button class="btn-action btn-buy-now" @click="buy" type="button">
                  <span>立即购买</span>
                  <i class="el-icon-right"></i>
                </button>
                <!-- 加入购物车 -->
                <button class="btn-action btn-add-cart" @click="addToCart" type="button">
                  <i class="el-icon-shopping-cart-2"></i>
                  <span>加入购物车</span>
                </button>
                <!-- 加入常购清单 -->
                <button class="btn-action btn-add-regular" @click="showDialogVisible" type="button">
                  <i class="el-icon-collection-tag"></i>
                  <span>加入常购清单</span>
                </button>
              </div>
            </template>
            <div class="unpurchasable-panel" v-else>
              <i class="el-icon-warning"></i>
              <span>该物资目前处于非可采状态，如需调配请联系企业专属客户经理。</span>
            </div>
          </div>

          <!-- 7. 政企阳光直采四大服务承诺标签 -->
          <div class="guarantee-footer-strip">
            <div class="guarantee-item">
              <i class="el-icon-circle-check"></i>
              <span>官方正品保障</span>
            </div>
            <div class="guarantee-item">
              <i class="el-icon-van"></i>
              <span>协议专线直发</span>
            </div>
            <div class="guarantee-item">
              <i class="el-icon-tickets"></i>
              <span>增税专票一键开具</span>
            </div>
            <div class="guarantee-item">
              <i class="el-icon-service"></i>
              <span>1对1 专属销售代表</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 3. 下方 Tab 详情切换区 (严格还原系统真实数据：商品介绍 / 规格型号 / 供应商名称) -->
    <section class="tabs-detail-card">
      <!-- Tab 切换头部 -->
      <div class="tab-header-strip">
        <button
          v-for="(item, index) in tagList"
          :key="'tag-' + index"
          type="button"
          class="tab-btn"
          :class="{ 'is-active': curIndex === index }"
          @click="changeIndex(index)"
        >
          <span>{{ item }}</span>
          <span class="tab-indicator" v-if="curIndex === index"></span>
        </button>
      </div>

      <!-- Tab 面板内容容器 -->
      <div class="tab-panel-body" :class="{ 'is-intro-tab': curIndex === 0 }">
        <!-- 骨架屏加载中 -->
        <div class="tab-skeleton" v-if="detailLoading">
          <div class="skeleton-shimmer"></div>
          <div class="sk-line sk-tab-line" v-for="n in 5" :key="n"></div>
        </div>

        <template v-else>
          <!-- Tab 0: 商品介绍 (真实多图或真实富文本) -->
          <div class="tab-pane-content" v-if="curIndex === 0">
            <!-- 真实多图详情 -->
            <div
              class="images-gallery-body"
              v-if="detail.tucgev7e0xvjfgij && detail.tucgev7e0xvjfgij.length"
            >
              <img
                :src="item.url"
                :alt="detail.avdrlfwlhg7kywxn || '详情图'"
                v-for="(item, index) in detail.tucgev7e0xvjfgij"
                :key="index"
                class="detail-full-img"
              />
            </div>
            <!-- 真实富文本详情 -->
            <div
              class="richtext-container"
              v-else-if="detail.xwkkrha3mtpeybgy && detail.xwkkrha3mtpeybgy !== '<p><br></p>'"
              v-html="detail.xwkkrha3mtpeybgy"
            ></div>
            <!-- 真实空状态 -->
            <div class="empty-tab-panel" v-else>
              <div class="empty-icon-wrap">
                <i class="el-icon-document-remove"></i>
              </div>
              <p class="empty-title">暂无商品图文介绍</p>
              <p class="empty-desc">该物料暂未上传图文扩展介绍，请参考规格型号或咨询在线专属顾问。</p>
            </div>
          </div>

          <!-- Tab 1: 规格型号 (真实富文本 se3jrkgoqrxa6sgt) -->
          <div class="tab-pane-content" v-else-if="curIndex === 1">
            <div
              class="richtext-container"
              v-if="detail.se3jrkgoqrxa6sgt && detail.se3jrkgoqrxa6sgt !== '<p><br></p>'"
              v-html="detail.se3jrkgoqrxa6sgt"
            ></div>
            <div class="empty-tab-panel" v-else>
              <div class="empty-icon-wrap">
                <i class="el-icon-c-scale-to-original"></i>
              </div>
              <p class="empty-title">暂无规格型号说明</p>
              <p class="empty-desc">该商品暂未录入专用规格参数，请按物料 SKU 订货编码核对。</p>
            </div>
          </div>

          <!-- Tab 2: 供应商名称 (真实企业资质 cijhopahvvolyisa) -->
          <div class="tab-pane-content" v-else-if="curIndex === 2">
            <div
              class="supplier-card-box"
              v-if="detail.cijhopahvvolyisa && detail.cijhopahvvolyisa.length > 0"
            >
              <div class="supplier-header">
                <div class="supplier-avatar">
                  <i class="el-icon-office-building"></i>
                </div>
                <div class="supplier-meta">
                  <div class="supplier-name">
                    {{ detail.cijhopahvvolyisa[0].value }}
                  </div>
                  <div class="supplier-tags">
                    <span class="tag-pill verified">
                      <i class="el-icon-circle-check"></i> 签约入库供应商
                    </span>
                    <span class="tag-pill credit">
                      <i class="el-icon-medal"></i> 框架协议履约认证
                    </span>
                  </div>
                </div>
              </div>
              <div class="supplier-info-grid">
                <div class="grid-item">
                  <span class="item-label">合作模式：</span>
                  <span class="item-val">框架协议入库直供</span>
                </div>
                <div class="grid-item">
                  <span class="item-label">开票资质：</span>
                  <span class="item-val">13% 增值税专用发票</span>
                </div>
                <div class="grid-item">
                  <span class="item-label">对账模式：</span>
                  <span class="item-val">企业月结 / 自动对账系统联通</span>
                </div>
                <div class="grid-item">
                  <span class="item-label">品质保障：</span>
                  <span class="item-val">原厂正品行货 假一赔十</span>
                </div>
              </div>
            </div>
            <div class="empty-tab-panel" v-else>
              <div class="empty-icon-wrap">
                <i class="el-icon-user"></i>
              </div>
              <p class="empty-title">供应商信息待完善</p>
              <p class="empty-desc">本商品由科普特企业采购平台统一提供框架协议履约与售后服务。</p>
            </div>
          </div>
        </template>
      </div>
    </section>

    <!-- 4. 加入常购清单分组管理弹窗 (适配深蓝科技规范，100% 保持业务功能) -->
    <el-dialog
      title="加入常购清单分组"
      :visible.sync="dialogVisible"
      width="460px"
      :show-close="true"
      :close-on-click-modal="false"
      class="group-dialog"
    >
      <div class="dialog-body-box">
        <p class="dialog-hint">请选择归属的清单分组，以便部门高频集采复购：</p>
        <div class="select-with-add">
          <el-select v-model="group" placeholder="请选择常购清单分组" class="group-select">
            <el-option
              v-for="item in groupList"
              :key="item.id"
              :label="item.izclrsecwsxu9yfg"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-button type="text" class="add-group-link" @click="addGroup">
            <i class="el-icon-plus"></i> 新增分组
          </el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="medium">取 消</el-button>
        <el-button type="primary" @click="addToFrequentPurchaseList()" size="medium" :disabled="!group">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import NumberInput from "../../components/NumberInput";
import { detailOnline, relationFieldButtonExc, online, postOnline } from "@/api/platform";

export default {
  name: "GoodsDetail",
  components: {
    NumberInput,
  },
  computed: {
    id () {
      return this.$route.params.id;
    },
    canPurchase () {
      return this.detail['2ubunrqlyoz3re9q'] !== '00bd865a-258c-4cf7-a79a-10124f2396e2';
    },
    formattedPrice () {
      const p = this.detail.f93blbqlvdtdt65v;
      if (p === null || p === undefined || p === "") {
        return "0.00";
      }
      const num = Number(p);
      return Number.isFinite(num) ? num.toFixed(2) : String(p);
    },
  },
  data () {
    return {
      num: 1,
      tagList: ["商品介绍", "规格型号", "供应商名称"],
      curIndex: 0,
      detail: {},
      detailLoading: true,
      activeImgIndex: 0,
      dialogVisible: false, // 分组弹窗
      groupList: [], // 分组列表
      group: '', // 分组id
    };
  },
  mounted () {
    this.detailOnline(this.id);
    this.getGroupList();
  },
  methods: {
    async detailOnline (id) {
      this.detailLoading = true;
      try {
        const { result } = await detailOnline({
          id,
          form_head_uuid: "4b9b935758484c01bb3d8e2d1e08211f",
        });
        this.detail = result || {};
      } catch (error) {
        this.detail = {};
      } finally {
        this.detailLoading = false;
      }
    },
    // 获取分组列表
    async getGroupList () {
      try {
        const { result } = await online({
          form_head_uuid: 'fde4a97f88444d9599a9bbf4778a2767',
          page: 1,
          limit: 1000,
          keyword: "",
          select_option: "",
        });
        this.groupList = result || [];
      } catch (error) {
        this.groupList = [];
      }
    },
    // 展示分组管理弹窗
    showDialogVisible () {
      this.dialogVisible = true;
      this.group = '';
    },
    changeIndex (i) {
      this.curIndex = i;
    },
    // 缩略图选择与联动
    selectThumb (idx) {
      this.activeImgIndex = idx;
      if (this.$refs.carousel) {
        this.$refs.carousel.setActiveItem(idx);
      }
    },
    handleCarouselChange (idx) {
      this.activeImgIndex = idx;
    },
    // 复制SKU编码
    copySku (text) {
      if (!text) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('SKU 订货编码已复制');
        }).catch(() => {
          this.fallbackCopy(text);
        });
      } else {
        this.fallbackCopy(text);
      }
    },
    fallbackCopy (text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message.success('SKU 订货编码已复制');
    },
    // 加入购物车 (保留原有业务入参与按钮UUID)
    async addToCart () {
      await relationFieldButtonExc({
        data: { bhekk5pld5l117tl: this.num },
        button_uuid: "e3bd545a-7298-4a1c-9441-6a69d58cc092",
        ids: [this.detail.id],
        form_head_uuid: "4b9b935758484c01bb3d8e2d1e08211f",
      });
      this.$notify({
        title: "成功加入购物车",
        message: `商品已成功加入购物车，数量：${this.num}`,
        type: "success",
      });
      this.num = 1;
      this.$store.dispatch('getCartQuantity');
    },
    // 新增常购分组 (保留原有业务调用)
    addGroup () {
      this.$prompt('请输入新增的清单分组名称（如：后勤行政、打印耗材）', '新建清单分组', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S+/,
        inputErrorMessage: '分组名称不能为空'
      }).then(async ({ value }) => {
        if (value) {
          await postOnline({
            form_head_uuid: "fde4a97f88444d9599a9bbf4778a2767",
            izclrsecwsxu9yfg: value,
          });
          this.$message({
            type: 'success',
            message: '常购分组创建成功'
          });
          await this.getGroupList();
        }
      }).catch(() => {});
    },
    // 加入常购清单 (保留原有业务入参与按钮UUID)
    async addToFrequentPurchaseList () {
      if (!this.group) {
        this.$message.warning("请先选择目标分组");
        return;
      }
      await relationFieldButtonExc({
        data: { abv2ns1jpglwrhpt: this.group, cqciysjw6yzbccda: this.num },
        button_uuid: "4aeb190e-43e6-4ed3-99aa-33d7d1bc24aa",
        ids: [this.detail.id],
        form_head_uuid: "1906dfc5e0ce4e7cb7d6324b06e6d470",
      });
      this.$notify({
        title: "已加入常购清单",
        message: "商品已成功归档到常购清单分组",
        type: "success",
      });
      this.dialogVisible = false;
      this.num = 1;
    },
    // 立即购买 (保留原有 store 与跳转路由)
    buy () {
      this.$store.commit('setData', {
        commodityList: [this.detail],
        number: this.num
      });
      this.$router.push('/mall/createOrder?form=detail');
    },
  },
  watch: {
    $route () {
      this.detailOnline(this.id);
    },
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';

.GoodsDetail {
  padding: 16px 0 60px;



  // 2. 商品核心卡片
  .goods-main-card {
    background-color: #ffffff;
    border: 1px solid @brandBorder;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 40, 100, 0.04);
    padding: 32px;
    margin-bottom: 24px;
    box-sizing: border-box;

    .main-card-layout {
      display: grid;
      grid-template-columns: 460px 1fr;
      gap: 40px;
    }

    // 左侧画廊
    .gallery-col {
      display: flex;
      flex-direction: column;
      align-items: center;

      .main-gallery-stage {
        position: relative;
        width: 100%;
        height: 420px;
        background-color: #f8fafc;
        border: 1px solid #e2e8f0;
        border-radius: 10px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;

        .corp-self-badge {
          position: absolute;
          top: 12px;
          left: 12px;
          z-index: 10;
          background-color: @brandPrimary;
          color: #ffffff;
          font-size: 11px;
          font-weight: 600;
          padding: 3px 8px;
          border-radius: 4px;
          box-shadow: 0 2px 6px rgba(15, 82, 186, 0.25);
          display: flex;
          align-items: center;
          gap: 4px;
        }

        .carousel-stage {
          width: 100%;
          height: 100%;

          .gallery-img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            mix-blend-mode: multiply;
          }
        }

        .no-img-stage {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
          color: #94a3b8;
          font-size: 13px;

          .no-img-icon {
            font-size: 48px;
            color: #cbd5e1;
          }
        }
      }

      // 缩略图横条
      .thumbnails-strip {
        display: flex;
        gap: 10px;
        margin-top: 14px;
        width: 100%;
        overflow-x: auto;
        padding-bottom: 4px;

        .thumb-item {
          width: 60px;
          height: 60px;
          border-radius: 6px;
          border: 2px solid transparent;
          background-color: #f8fafc;
          padding: 4px;
          cursor: pointer;
          flex-shrink: 0;
          transition: all 0.15s ease;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            mix-blend-mode: multiply;
          }

          &:hover {
            border-color: #94a3b8;
          }

          &.is-active {
            border-color: @brandPrimary;
            box-shadow: 0 0 0 1px @brandPrimary;
          }
        }
      }
    }

    // 右侧决策区
    .decision-col {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .goods-heading {
        font-size: 20px;
        font-weight: 700;
        color: @brandTextDark;
        line-height: 1.45;
        margin: 0 0 12px;
        letter-spacing: -0.2px;
      }

      // SKU与现货状态
      .meta-sku-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 14px;
        margin-bottom: 16px;
        border-bottom: 1px solid #f1f5f9;

        .sku-capsule {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background-color: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          padding: 4px 10px;
          font-size: 12px;

          .sku-label {
            color: @brandTextLight;
            display: flex;
            align-items: center;
            gap: 4px;
          }

          .sku-code {
            color: @brandPrimary;
            font-size: 13px;
            letter-spacing: 0.5px;
          }

          .sku-copy-link {
            border: none;
            background: none;
            color: @brandContainer;
            cursor: pointer;
            font-size: 11px;
            font-weight: 600;
            padding: 0 2px;
            border-left: 1px solid #cbd5e1;
            padding-left: 8px;

            &:hover {
              text-decoration: underline;
            }
          }
        }

        .stock-live-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          font-size: 12px;
          color: #10b981;
          font-weight: 600;

          .live-dot {
            width: 7px;
            height: 7px;
            background-color: #10b981;
            border-radius: 50%;
            box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2);
          }
        }
      }

      // 价格看板
      .price-dashboard {
        background: linear-gradient(135deg, #f0f5ff 0%, #f8fafc 100%);
        border: 1px solid rgba(15, 82, 186, 0.15);
        border-radius: 10px;
        padding: 16px 20px;
        margin-bottom: 20px;

        .price-primary-row {
          display: flex;
          align-items: baseline;
          gap: 12px;

          .price-type-label {
            font-size: 13px;
            font-weight: 600;
            color: @brandPrimary;
          }

          .price-amount-wrap {
            display: flex;
            align-items: baseline;
            color: @brandPrimary;

            .currency {
              font-size: 20px;
              font-weight: 700;
              margin-right: 2px;
            }

            .amount-number {
              font-size: 32px;
              font-weight: 800;
              letter-spacing: -0.5px;
            }
          }

          .discount-pill {
            background-color: rgba(15, 82, 186, 0.08);
            color: @brandPrimary;
            border: 1px solid rgba(15, 82, 186, 0.2);
            font-size: 11px;
            font-weight: 600;
            padding: 2px 8px;
            border-radius: 4px;
          }
        }

        .tax-shipping-footer {
          margin-top: 10px;
          padding-top: 10px;
          border-top: 1px solid rgba(15, 82, 186, 0.1);
          display: flex;
          flex-direction: column;
          gap: 4px;
          font-size: 12px;
          color: @brandTextLight;

          .footer-item {
            display: flex;
            align-items: center;
            gap: 6px;

            .accent-icon {
              color: @brandPrimary;
            }

            strong {
              color: @brandTextDark;
              font-weight: 500;
            }
          }
        }
      }

      // 规格与数量操作
      .specs-attributes-box {
        display: flex;
        flex-direction: column;
        gap: 16px;

        .attr-row {
          display: flex;
          align-items: center;

          .attr-label {
            width: 72px;
            font-size: 13px;
            color: @brandTextLight;
            flex-shrink: 0;
          }

          .unit-capsule {
            display: inline-flex;
            align-items: center;
            gap: 4px;
            padding: 4px 14px;
            background-color: #f8fafc;
            border: 1px solid #cbd5e1;
            border-radius: 6px;
            font-size: 13px;
            font-weight: 600;
            color: @brandTextDark;

            .check-mark {
              color: @brandPrimary;
              font-size: 12px;
            }
          }

          &.quantity-row {
            align-items: center;

            .quantity-picker-wrap {
              display: flex;
              align-items: center;
              gap: 12px;

              .qty-desc {
                font-size: 12px;
                color: #94a3b8;
              }
            }
          }
        }

        // 三大操作按钮
        .actions-button-row {
          display: flex;
          align-items: center;
          gap: 12px;
          padding-top: 10px;

          .btn-action {
            height: 44px;
            padding: 0 24px;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
            box-sizing: border-box;

            // 立即购买
            &.btn-buy-now {
              background-color: #f0f5ff;
              border: 1.5px solid @brandPrimary;
              color: @brandPrimary;

              &:hover {
                background-color: @brandPrimary;
                color: #ffffff;
                box-shadow: 0 4px 12px rgba(15, 82, 186, 0.25);
              }
            }

            // 加入购物车
            &.btn-add-cart {
              background-color: @brandPrimary;
              border: 1.5px solid @brandPrimary;
              color: #ffffff;
              box-shadow: 0 4px 14px rgba(15, 82, 186, 0.2);

              &:hover {
                background-color: @brandContainer;
                border-color: @brandContainer;
                transform: translateY(-1px);
                box-shadow: 0 6px 18px rgba(15, 82, 186, 0.3);
              }
            }

            // 加入常购清单
            &.btn-add-regular {
              background-color: #ffffff;
              border: 1px solid #cbd5e1;
              color: @brandTextDark;

              &:hover {
                border-color: @brandPrimary;
                color: @brandPrimary;
                background-color: #f8fafc;
              }
            }
          }
        }

        .unpurchasable-panel {
          background-color: #fff7ed;
          border: 1px solid #ffedd5;
          color: #c2410c;
          padding: 12px 16px;
          border-radius: 6px;
          font-size: 13px;
          display: flex;
          align-items: center;
          gap: 8px;
        }
      }

      // 四大服务承诺
      .guarantee-footer-strip {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 12px;
        margin-top: 24px;
        padding-top: 18px;
        border-top: 1px solid #f1f5f9;

        .guarantee-item {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 12px;
          color: @brandTextLight;

          i {
            color: @brandPrimary;
            font-size: 14px;
          }
        }
      }
    }
  }

  // 3. 下方 Tab 详情工作台
  .tabs-detail-card {
    background-color: #ffffff;
    border: 1px solid @brandBorder;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 40, 100, 0.04);
    overflow: hidden;

    .tab-header-strip {
      display: flex;
      align-items: center;
      background-color: #f8fafc;
      border-bottom: 1px solid #e2e8f0;

      .tab-btn {
        position: relative;
        padding: 16px 28px;
        font-size: 14px;
        font-weight: 500;
        color: @brandTextLight;
        background: none;
        border: none;
        cursor: pointer;
        transition: all 0.15s ease;

        &:hover {
          color: @brandPrimary;
        }

        &.is-active {
          color: @brandPrimary;
          font-weight: 700;
          background-color: #ffffff;

          .tab-indicator {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 3px;
            background-color: @brandPrimary;
          }
        }
      }
    }

    .tab-panel-body {
      padding: 32px;
      min-height: 280px;

      &.is-intro-tab {
        padding: 0; // 商品介绍 Tab 满宽无留白展示
      }

      // 骨架占位
      .tab-skeleton {
        display: flex;
        flex-direction: column;
        gap: 14px;
        position: relative;
        overflow: hidden;

        .sk-tab-line {
          height: 18px;
          background-color: #f1f5f9;
          border-radius: 4px;

          &:nth-child(1) { width: 40%; }
          &:nth-child(2) { width: 85%; }
          &:nth-child(3) { width: 70%; }
          &:nth-child(4) { width: 95%; }
          &:nth-child(5) { width: 60%; }
        }
      }

      // 图集展示 (全屏等比例 fill-width 展开)
      .images-gallery-body {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        gap: 0;

        .detail-full-img {
          width: 100%;
          max-width: 100%;
          height: auto;
          display: block;
          vertical-align: bottom;
        }
      }

      // 富文本详情容器
      .richtext-container {
        width: 100%;
        line-height: 1.8;
        font-size: 14px;
        color: @brandTextDark;

        /deep/ p {
          margin: 0;
          padding: 0;
        }

        /deep/ img {
          width: 100% !important;
          max-width: 100% !important;
          height: auto !important;
          display: block;
          margin: 0 auto;
        }

        /deep/ table {
          border-collapse: collapse;
          width: 100%;
          margin: 16px 0;

          td, th {
            border: 1px solid #e2e8f0;
            padding: 8px 12px;
            font-size: 13px;
          }

          th {
            background-color: #f8fafc;
            font-weight: 600;
          }
        }
      }

      // 供应商名片
      .supplier-card-box {
        background-color: #f8fafc;
        border: 1px solid #e2e8f0;
        border-radius: 10px;
        padding: 24px;
        max-width: 800px;

        .supplier-header {
          display: flex;
          align-items: center;
          gap: 16px;
          padding-bottom: 18px;
          border-bottom: 1px solid #e2e8f0;

          .supplier-avatar {
            width: 48px;
            height: 48px;
            background-color: @brandPrimary;
            color: #ffffff;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
            box-shadow: 0 4px 10px rgba(15, 82, 186, 0.2);
          }

          .supplier-name {
            font-size: 17px;
            font-weight: 700;
            color: @brandTextDark;
            margin-bottom: 6px;
          }

          .supplier-tags {
            display: flex;
            gap: 8px;

            .tag-pill {
              font-size: 11px;
              font-weight: 600;
              padding: 2px 8px;
              border-radius: 4px;

              &.verified {
                background-color: #ecfdf5;
                color: #059669;
                border: 1px solid #a7f3d0;
              }

              &.credit {
                background-color: #eff6ff;
                color: #2563eb;
                border: 1px solid #bfdbfe;
              }
            }
          }
        }

        .supplier-info-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 14px;
          margin-top: 18px;

          .grid-item {
            font-size: 13px;

            .item-label {
              color: @brandTextLight;
            }

            .item-val {
              color: @brandTextDark;
              font-weight: 500;
            }
          }
        }
      }

      // 空状态
      .empty-tab-panel {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 60px 20px;
        text-align: center;

        .empty-icon-wrap {
          width: 56px;
          height: 56px;
          background-color: #f1f5f9;
          color: #94a3b8;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 26px;
          margin-bottom: 12px;
        }

        .empty-title {
          font-size: 15px;
          font-weight: 600;
          color: @brandTextDark;
          margin: 0 0 6px;
        }

        .empty-desc {
          font-size: 13px;
          color: @brandTextLight;
          max-width: 400px;
          margin: 0;
          line-height: 1.5;
        }
      }
    }
  }

  // 骨架屏基础动效
  .skeleton-card {
    position: relative;
    overflow: hidden;

    .sk-image-box {
      width: 100%;
      height: 420px;
      background-color: #f1f5f9;
      border-radius: 10px;
    }

    .sk-thumbs-row {
      display: flex;
      gap: 10px;
      margin-top: 14px;

      .sk-thumb {
        width: 60px;
        height: 60px;
        background-color: #f1f5f9;
        border-radius: 6px;
      }
    }

    .sk-line {
      background-color: #f1f5f9;
      border-radius: 4px;
      margin-bottom: 14px;

      &.sk-title {
        height: 28px;
        width: 80%;
      }

      &.sk-sku {
        height: 20px;
        width: 45%;
      }

      &.sk-spec {
        height: 24px;
        width: 30%;
      }

      &.sk-qty {
        height: 36px;
        width: 40%;
      }
    }

    .sk-price-box {
      height: 90px;
      background-color: #f1f5f9;
      border-radius: 10px;
      margin-bottom: 20px;
    }

    .sk-buttons-row {
      display: flex;
      gap: 12px;
      margin-top: 20px;

      .sk-btn {
        width: 140px;
        height: 44px;
        background-color: #f1f5f9;
        border-radius: 8px;
      }
    }
  }

  .skeleton-shimmer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(241, 245, 249, 0.75) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    transform: translateX(-100%);
    animation: shimmerMove 1.5s infinite;
    pointer-events: none;
    z-index: 5;
  }
}

// 分组弹窗样式定制
.group-dialog {
  /deep/ .el-dialog {
    border-radius: 10px;
    overflow: hidden;
  }

  /deep/ .el-dialog__header {
    background-color: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    padding: 16px 20px;

    .el-dialog__title {
      font-size: 15px;
      font-weight: 700;
      color: @brandTextDark;
    }
  }

  .dialog-body-box {
    padding: 10px 0;

    .dialog-hint {
      font-size: 13px;
      color: @brandTextLight;
      margin: 0 0 12px;
    }

    .select-with-add {
      display: flex;
      align-items: center;
      gap: 10px;

      .group-select {
        flex: 1;
      }

      .add-group-link {
        color: @brandPrimary;
        font-weight: 600;
        font-size: 13px;
        flex-shrink: 0;
      }
    }
  }
}

@keyframes shimmerMove {
  100% {
    transform: translateX(100%);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/client/GoodsDetail.vue